(() => {
  const page = document.querySelector('[data-vc-page]');
  if (!page || !('IntersectionObserver' in window)) return;
  const items = page.querySelectorAll('.vc-series__heading, .vc-card, .vc-feature > *');
  items.forEach((item) => item.classList.add('vc-reveal'));
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
  items.forEach((item) => observer.observe(item));
})();
